// extracted by mini-css-extract-plugin
export var completionBody = "_ci-2";
export var completionCard = "_ci-0";
export var completionFooter = "_ci-3";
export var completionTitle = "_ci-1";